import OneXTwoImage from '../../assets/images/casinoproviders/1x2gaming.svg';
import SevenMojos from '../../assets/images/casinoproviders/7mojos.svg';
import AdLunam from '../../assets/images/casinoproviders/ad-lunam.svg';
import BetGames from '../../assets/images/casinoproviders/Bet_Games.svg';
import Dragonsoft from '../../assets/images/casinoproviders/dragonsoft.svg';
import ElkStudios from '../../assets/images/casinoproviders/elk-provider.svg';
import EvoPlay from '../../assets/images/casinoproviders/evo-play.svg';
import FaChai from '../../assets/images/casinoproviders/fa-chai.svg';
import Galaxsys from '../../assets/images/casinoproviders/galaxsys.svg';
import GameArt from '../../assets/images/casinoproviders/gameart.svg';
import GamingCorps from '../../assets/images/casinoproviders/gamingCorps.svg';
import HoGaming from '../../assets/images/casinoproviders/ho-gaming.svg';
import IronDogStudios from '../../assets/images/casinoproviders/irondogstudio.svg';
import KalambaGames from '../../assets/images/casinoproviders/kalamba-games.svg';
import NetGameEntertainment from '../../assets/images/casinoproviders/net-game-entertainment.svg';
import OmiGaming from '../../assets/images/casinoproviders/omi-gaming.svg';
import OneTouch from '../../assets/images/casinoproviders/onetouch-gaming.svg';
import ProspectGaming from '../../assets/images/casinoproviders/prospect-gaming.svg';
import RevolverGaming from '../../assets/images/casinoproviders/revolver-gaming.svg';
import RivalPowered from '../../assets/images/casinoproviders/rival-powered.svg';
import RTGSlots from '../../assets/images/casinoproviders/rtg-slots.svg';
import SAGaming from '../../assets/images/casinoproviders/SA-Gaming.svg';
import SkywindGaming from '../../assets/images/casinoproviders/skywind-gaming.svg';
import SlotmillGames from '../../assets/images/casinoproviders/slotmill-games.svg';
import SpearHeadStudios from '../../assets/images/casinoproviders/SpearheadStudios.svg';
import TriplePG from '../../assets/images/casinoproviders/Triple-PG.svg';
import TurboGames from '../../assets/images/casinoproviders/turbo-games.svg';
import VivoGaming from '../../assets/images/casinoproviders/vivo-gaming.svg';
import WoohooGaming from '../../assets/images/casinoproviders/woohoo-gaming.svg';


export const CasinoProviderDATA = [
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: OneXTwoImage,
        name: '1X2 Gaming',
        provider: '1x2'
    },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: SevenMojos,
    //     name: '7Mojos Casino', 
    //     provider: '7MC'
    // },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: AdLunam,
    //     name: 'Ad Lunam', 
    //     provider: 'ADL'
    // },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: "https://luckmedia.link/providers/aux/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'AvatarUX', 
        provider: 'AUX'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: "https://luckmedia.link/providers/btr/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'BETER Live', 
        provider: 'BTL'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: BetGames,
        name: 'BetGames.TV', 
        provider: 'BTV'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: 'https://luckmedia.link/providers/btg/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format',
        name: 'Big Time Gaming', 
        provider: 'BTG'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: 'https://luckmedia.link/providers/blg/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format',
        name: 'Blueprint Gaming', 
        provider: 'BPG'
    },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: 'https://luckmedia.link/providers/jil/logo_3_2_cl_dark.svg',
    //     name: 'Jili Games', 
    //     provider: 'JIL'
    // },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: 'https://luckmedia.link/providers/bng/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format',
        name: 'Booongo', 
        provider: 'BNG'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: 'https://luckmedia.link/providers/cqc/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format',
        name: 'CQ9 Casino', 
        provider: 'CQC'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: Dragonsoft,
        name: 'Dragoon Soft', 
        provider: 'DS'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: ElkStudios,
        name: 'Elk Studios', 
        provider: 'ELK'
    },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: 'https://luckmedia.link/providers/end/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format',
    //     name: 'Endorphina', 
    //     provider: 'END'
    // },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: 'https://luckmedia.link/providers/evo/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format',
        name: 'Evolution Gaming', 
        provider: 'EVO'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: EvoPlay,
        name: 'Evoplay', 
        provider: 'EVP'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: 'https://luckmedia.link/providers/ezg/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format',
        name: 'Ezugi', 
        provider: 'EZU'
    },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: FaChai,
    //     name: 'Fa Chai', 
    //     provider: 'FCG'
    // },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: "https://luckmedia.link/providers/fnt/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Fantasma Games', 
        provider: 'FNG' 
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: "https://luckmedia.link/providers/fgs/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Fugaso', 
        provider: 'FUG' 
    },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: Galaxsys,
    //     name: 'Galaxsys', 
    //     provider: 'GLX'
    // },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: GameArt,
        name: 'GAMEART', 
        provider: 'GA'
    },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: GamingCorps,
    //     name: 'Gaming Corps', 
    //     provider: 'GMC'
    // },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: 'https://luckmedia.link/providers/gmz/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format',
        name: 'Gamzix', 
        provider: 'GZX'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: 'https://luckmedia.link/providers/hbn/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format',
        name: 'Habanero', 
        provider: 'HAB'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: 'https://luckmedia.link/providers/hcw/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format',
        name: 'Hacksaw Gaming', 
        provider: 'HAK'
    },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: HoGaming,
    //     name: 'Ho Gaming', 
    //     provider: 'HOG'
    // },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: IronDogStudios,
        name: 'Iron Dog Studio', 
        provider: 'IDS'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: KalambaGames,
        name: 'Kalamba Games', 
        provider: 'KGL'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: "https://luckmedia.link/providers/kir/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Kiron Interactive', 
        provider: 'KIR'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: "https://luckmedia.link/providers/mnn/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Manna Play', 
        provider: 'MNP'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: "https://luckmedia.link/providers/mbl/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Mobilots', 
        provider: 'MOB'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: "https://luckmedia.link/providers/ntn/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'NetEnt', 
        provider: 'NE'
    },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: NetGameEntertainment,
    //     name: 'NetGame Entertainment', 
    //     provider: 'NGE'
    // },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: 'https://luckmedia.link/providers/nlc/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format',
        name: 'Nolimit city', 
        provider: 'NLC'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: OmiGaming,
        name: 'OMI Gaming', 
        provider: 'OMI'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: OneTouch,
        name: 'OneTouch', 
        provider: 'OT'
    },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: "https://luckmedia.link/providers/onl/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
    //     name: 'Onlyplay', 
    //     provider: 'OPY'
    // },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: "https://luckmedia.link/providers/png/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'PLAY’n GO', 
        provider: 'PNG'
    },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: "https://luckmedia.link/providers/plt/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
    //     name: 'Playtech Casino', 
    //     provider: 'PTC'
    // },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: "https://luckmedia.link/providers/pnt/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Print Studios', 
        provider: 'PRS'
    },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: ProspectGaming,
    //     name: 'Prospect Gaming', 
    //     provider: 'PRG' 
    // },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: "https://luckmedia.link/providers/psh/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Push Gaming', 
        provider: 'PUG'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: "https://luckmedia.link/providers/qps/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Quickspin', 
        provider: 'QS'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: "https://luckmedia.link/providers/rtg/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Red Tiger', 
        provider: 'RED'
    },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: "https://luckmedia.link/providers/reg/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
    //     name: 'Relax Gaming', 
    //     provider: 'RLX'
    // },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: RevolverGaming,
    //     name: 'Revolver Gaming', 
    //     provider: 'RG'
    // },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: RivalPowered,
    //     name: 'Rival Powered', 
    //     provider: 'RVP'
    // },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: RTGSlots,
        name: 'RTG Slots', 
        provider: 'RTG'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: SAGaming,
        name: 'SA Gaming', 
        provider: 'SAG'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: SkywindGaming,
        name: 'Skywind Casino', 
        provider: 'SWC'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: SlotmillGames,
        name: 'Slotmill', 
        provider: 'SM'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: SpearHeadStudios,
        name: 'Spearhead Studios', 
        provider: 'SHS'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: "https://luckmedia.link/providers/spb/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Spribe', 
        provider: 'SPB'
    },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: "https://luckmedia.link/providers/tdk/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
    //     name: 'Thunderkick', 
    //     provider: 'TK'
    // },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: TriplePG,
        name: 'Triple PG', 
        provider: 'TPG'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: TurboGames,
        name: 'Turbo Games', 
        provider: 'TRB'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: VivoGaming,
        name: 'Vivo Gaming', 
        provider: 'VGL'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: "https://luckmedia.link/providers/wzd/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Wazdan', 
        provider: 'WAZ'
    },
    {
        eventId: '99999',
        eventType: '99999',
        eventTypeId: '99999',
        backgroundColour: '',
        image: WoohooGaming,
        name: 'Woohoo Games', 
        provider: 'WOO'
    },
    // {
    //     eventId: '99999',
    //     eventType: '99999',
    //     eventTypeId: '99999',
    //     backgroundColour: '',
    //     image: "https://luckmedia.link/providers/ygg/logo_3_2_cl_dark.svg?q=65&amp;w=600&amp;px=auto&amp;auto=format",
    //     name: 'Yggdrasil', 
    //     provider: 'YGG'
    // },
];